// Currency conversion rates (in practice, these would come from an API)
const exchangeRates: Record<string, number> = {
  USD: 1.00,  // Base currency
  EUR: 0.92,  // Euro
  GBP: 0.79,  // British Pound
}

// Base prices in USD
const basePrices = {
  professional: 29,
  studio: 99
}

export const formatPrice = (priceKey: 'professional' | 'studio', currencyCode: string): string => {
  const basePrice = basePrices[priceKey]
  const rate = exchangeRates[currencyCode] || 1
  const convertedPrice = Math.round(basePrice * rate)
  return convertedPrice.toString()
}

export const getCurrencySymbol = (currencyCode: string): string => {
  const symbols: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£'
  }
  
  return symbols[currencyCode] || '$'
}

export const formatCurrency = (amount: number, currencyCode: string): string => {
  const symbol = getCurrencySymbol(currencyCode)
  return `${symbol}${amount}`
}

// Get currency info for a language code (including regional variants)
export const getCurrencyForLanguage = (languageCode: string): { symbol: string; code: string } => {
  const currencyMap: Record<string, { symbol: string; code: string }> = {
    'en': { symbol: '$', code: 'USD' },        // Default to USD
    'en-us': { symbol: '$', code: 'USD' },     // United States
    'en-gb': { symbol: '£', code: 'GBP' },     // United Kingdom
    'es': { symbol: '€', code: 'EUR' },        // Spain
    'fr': { symbol: '€', code: 'EUR' },        // France
    'de': { symbol: '€', code: 'EUR' },        // Germany
    'pt': { symbol: '€', code: 'EUR' },        // Portugal
    'it': { symbol: '€', code: 'EUR' }         // Italy
  }
  
  // Check for exact match first, then fallback to base language
  const baseLanguageCode = languageCode.split('-')[0]
  return currencyMap[languageCode] || currencyMap[baseLanguageCode] || { symbol: '$', code: 'USD' }
}

// Get region-specific currency based on stored region preference
export const getCurrencyForRegion = (): { symbol: string; code: string } => {
  // First check for direct currency selection
  const selectedCurrency = localStorage.getItem('selectedCurrency')
  if (selectedCurrency) {
    return {
      symbol: getCurrencySymbol(selectedCurrency),
      code: selectedCurrency
    }
  }
  
  const selectedRegion = localStorage.getItem('selectedRegion')
  const selectedLanguage = localStorage.getItem('selectedLanguage')
  
  if (selectedRegion) {
    return getCurrencyForLanguage(selectedRegion)
  } else if (selectedLanguage) {
    return getCurrencyForLanguage(selectedLanguage)
  }
  
  // Default to USD for simplicity
  return { symbol: '$', code: 'USD' }
} 